import { segmentAnalytics as analytics } from '@hungryroot/segment';
export interface ProductAddedParams {
  productId: number;
  orderId: number;
  productName: string;
  category: 'groceries' | 'recipes';
  path: 'featured' | 'groceries' | 'recipes';
  modal: 'card' | 'RDP' | 'PDP';

  position: number;
  collectionId: string;
  collectionName: string;
}

export function productAdded(params: ProductAddedParams) {
  const {
    position,
    collectionId,
    collectionName,
    modal,
    path,
    category,
    productName,
    productId,
    orderId,
  } = params;
  analytics.track('product_added', {
    product_id: productId,
    order_id: orderId,
    product_name: productName,
    category,
    path,
    modal,

    position,
    collection_id: collectionId,
    collection_name: collectionName,
  });
}
